import { mapProductCard, type CatalogCard } from '../helpers/mapCatalog'
import { useDeliveryLocation } from './useDeliveryLocation'
import { useStorefrontCatalog } from './useStorefrontCatalog'

type CatalogState = {
  inRange: CatalogCard[]
  standard: CatalogCard[]
  plants: CatalogCard[]
  hasLocation: boolean
  locationLabel: string | null
  openLocation: () => void
  loading: boolean
  error: string | null
}

export function useCatalogProducts(): CatalogState {
  const { location, openModal } = useDeliveryLocation()
  const { catalog, hasLocation, loading, error } = useStorefrontCatalog()

  return {
    inRange: (catalog?.inRange ?? []).map(mapProductCard),
    standard: (catalog?.standard ?? []).map(mapProductCard),
    plants: (catalog?.plants ?? []).map(mapProductCard),
    hasLocation,
    locationLabel: location?.label ?? location?.city ?? null,
    openLocation: openModal,
    loading,
    error,
  }
}
